import type {
  MouseEvent as ReactMouseEvent,
  TouchEvent as ReactTouchEvent,
} from "react";
import {
  MouseSensor as LibMouseSensor,
  TouchSensor as LibTouchSensor,
} from "@dnd-kit/core";

export class MouseSensor extends LibMouseSensor {
  static activators = [
    {
      eventName: "onMouseDown" as const,
      handler: ({ nativeEvent: event }: ReactMouseEvent) => {
        return (
          event.button === 0 && shouldHandleEvent(event.target as HTMLElement)
        );
      },
    },
  ];
}

export class TouchSensor extends LibTouchSensor {
  static activators = [
    {
      eventName: "onTouchStart" as const,
      handler: ({ nativeEvent: event }: ReactTouchEvent) => {
        return shouldHandleEvent(event.target as HTMLElement);
      },
    },
  ];
}

function shouldHandleEvent(element: HTMLElement | null) {
  let cur = element;

  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }

  return true;
}

const textFieldSafeHandler = (event: MouseEvent | TouchEvent) => {
  const target = event.target as HTMLElement | null;

  if (!target) return false;

  // input/textareaが押されたときはドラッグさせない
  if (target.closest('input, textarea, [contenteditable="true"]')) {
    return false;
  }

  return true;
};

export class TextFieldSafeMouseSensor extends LibMouseSensor {
  static activators = [
    {
      eventName: "onMouseDown" as const,
      handler: ({ nativeEvent: event }: ReactMouseEvent) => {
        return event.button === 0 && textFieldSafeHandler(event);
      },
    },
  ];
}

export class TextFieldSafeTouchSensor extends LibTouchSensor {
  static activators = [
    {
      eventName: "onTouchStart" as const,
      handler: ({ nativeEvent: event }: ReactTouchEvent) => {
        if (event.touches.length > 1) {
          return false;
        }
        return textFieldSafeHandler(event);
      },
    },
  ];
}
